import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Grid,
  IconButton,
  Typography,
  Stack,
  Link,
  MenuList,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";

import store from "../../store";
import { setFamiliesData } from "../../store/actions/prescription";
import { getCustomerInfo, getSystemConstants } from "../../server/axios";
import { Header, MainColorButton, Loading } from "../../components";
import {
  CUSTOMER_PRE_INFO,
  CUSTOMER_UPDATER,
  MEDICAL_QUESTIONNAIRES_CUSTOMER_SELECTOR,
  PRESCRIPTION_HISTORY,
  MEDICAL_HISTORY,
} from "../../routes/path";
// アイコン
import userInformation from "./myPageIcon/userInformation.png";
import medicalInterview from "./myPageIcon/medicalInterview.png";
import usageHistory from "./myPageIcon/usageHistory.png";
import medicationBook from "./myPageIcon/medicationBook.png";
import help from "./myPageIcon/help.png";
import termsOfUse from "./myPageIcon/termsOfUse.png";

/**
 * マイページ
 * @returns
 */
const MyPage = () => {
  const navigate = useNavigate();
  const imgWidth = "20vw";
  const imgHeight = "20vw";
  const menuHeight = "8vh";
  const grayColor = "#dcdcdc";
  const whiteColor = "white";

  // 初期データ
  const [data, setData] = useState(null);
  const [userName, setUserName] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleHelp, setIsVisibleHelp] = useState(false);
  // 困ったときには
  const [isVisibleTerms, setIsVisibleTerms] = useState(false);
  // 規約
  const [isUserRegistered, setIsUserRegistered] = useState(false);
  const [urlList, setUrlList] = useState({
    rules: "",
    policy: "",
    guide: "",
    contact: "",
  });

  // Loadingコンポネント表示非表示state
  const [endY, setEndY] = useState(0);
  const [loadingOpen, setLoadingOpen] = useState(true);

  useEffect(() => {
    setLoadingOpen(true);
    (async () => {
      const selectLineInfo = (state) => state.prescription.lineInfo;
      const lineInfo = selectLineInfo(store.getState());

      const customerRes = await getCustomerInfo({ lineId: lineInfo.lineId });
      if (customerRes.data.isNew) {
        setIsUserRegistered(false);
      } else {
        setIsUserRegistered(true);
        setData(customerRes.data);
        setUserName(
          `${customerRes.data.lastName}${customerRes.data.firstName}`
        );
      }
      const tmpUrlList = { rules: "", policy: "", guide: "", contact: "" };
      const urlRes = await getSystemConstants({ isPharmacy: true });
      urlRes.data
        .filter((item) => item.ConstCd === "pharmacy_url")
        .forEach((item) => {
          switch (Number(item.ConstBranchCd)) {
            case 1:
              tmpUrlList.rules = item.ConstString;
              break;
            case 2:
              tmpUrlList.policy = item.ConstString;
              break;
            case 3:
              tmpUrlList.guide = item.ConstString;
              break;
            case 4:
              tmpUrlList.contact = item.ConstString;
              break;
            default:
              break;
          }
        });
      setUrlList(tmpUrlList);
      setLoadingOpen(false);
      setIsVisible(true);
    })();
  }, []);

  return (
    <Stack sx={{ width: "100vw", height: "100vh", bgcolor: grayColor }}>
      <Loading open={loadingOpen} />
      <Header title="マイページ" />
      <Stack
        sx={{
          width: "100vw",
          height: "80vh",
          overflowY: "scroll",
          visibility: isVisible ? "visible" : "hidden",
        }}
        position="fixed"
        onTouchStartCapture={(e) => {
          setEndY(0);
        }}
        onTouchMoveCapture={(e) => {
          setEndY(e.touches[0].clientY);
        }}
        onTouchEndCapture={(e) => {
          if (endY !== 0) {
            e.stopPropagation();
          }
        }}
      >
        <Stack width="95%" marginTop="9vh" marginLeft="auto" marginRight="auto">
          {isUserRegistered ? (
            <Grid item sx={{ ml: "5vw", my: "2vh" }}>
              <Typography variant="h5" align="left">
                {userName}様
              </Typography>
            </Grid>
          ) : (
            <Grid container direction="column">
              <Grid item>
                <Typography variant="h7" color="red" align="left">
                  ご利用には利用者登録が必要です。
                </Typography>
              </Grid>
              <Grid item sx={{ ml: "auto" }}>
                <MainColorButton
                  label="利用者登録はこちら"
                  style={{ height: "4vh" }}
                  onClick={() => navigate(CUSTOMER_PRE_INFO)}
                />
              </Grid>
            </Grid>
          )}
        </Stack>
        <Stack
          width="100%"
          marginTop="2vh"
          marginLeft="auto"
          marginRight="auto"
        >
          <Grid container direction="column">
            <Grid item>
              <MenuList
                sx={{
                  py: 0,
                  bgcolor: isUserRegistered ? whiteColor : grayColor,
                }}
              >
                <MenuItem
                  onClick={() => {
                    if (isUserRegistered) {
                      store.dispatch(setFamiliesData(data.families));
                      navigate(CUSTOMER_UPDATER, {
                        state: data,
                      });
                    }
                  }}
                  sx={{ borderTop: 1, borderBottom: 1, height: menuHeight }}
                >
                  <ListItemIcon sx={{ ml: 2 }}>
                    <img
                      alt="userInformation"
                      src={userInformation}
                      width={imgWidth}
                      height={imgHeight}
                    />
                  </ListItemIcon>
                  <ListItemText>利用者情報</ListItemText>
                  <IconButton size="large">
                    <KeyboardArrowRightIcon fontSize="large" />
                  </IconButton>
                </MenuItem>
                <MenuItem
                  sx={{ borderBottom: 1, height: menuHeight }}
                  onClick={() => {
                    if (isUserRegistered) {
                      navigate(MEDICAL_QUESTIONNAIRES_CUSTOMER_SELECTOR, {
                        state: data,
                      });
                    }
                  }}
                >
                  <ListItemIcon sx={{ ml: 2 }}>
                    <img
                      alt="medicalInterview"
                      src={medicalInterview}
                      width={imgWidth}
                      height={imgHeight}
                    />
                  </ListItemIcon>
                  <ListItemText>問診情報</ListItemText>
                  <IconButton size="large">
                    <KeyboardArrowRightIcon fontSize="large" />
                  </IconButton>
                </MenuItem>
                <MenuItem
                  sx={{ borderBottom: 1, height: menuHeight }}
                  onClick={() => {
                    if (isUserRegistered) {
                      navigate(PRESCRIPTION_HISTORY, {
                        state: data,
                      });
                    }
                  }}
                >
                  <ListItemIcon sx={{ ml: 2 }}>
                    <img
                      alt="usageHistory"
                      src={usageHistory}
                      width={imgWidth}
                      height={imgHeight}
                    />
                  </ListItemIcon>
                  <ListItemText>利用履歴</ListItemText>
                  <IconButton size="large">
                    <KeyboardArrowRightIcon fontSize="large" />
                  </IconButton>
                </MenuItem>
                <MenuItem
                  sx={{ borderBottom: 1, height: menuHeight }}
                  onClick={() => {
                    if (isUserRegistered) {
                      navigate(MEDICAL_HISTORY);
                    }
                  }}
                >
                  <ListItemIcon sx={{ ml: 2 }}>
                    <img
                      alt="medicationBook"
                      src={medicationBook}
                      width={imgWidth}
                      height={imgHeight}
                    />
                  </ListItemIcon>
                  <ListItemText>受取薬履歴</ListItemText>
                  <IconButton size="large">
                    <KeyboardArrowRightIcon fontSize="large" />
                  </IconButton>
                </MenuItem>
              </MenuList>
            </Grid>
            <Grid item sx={{ mt: "5vh" }}>
              <MenuList sx={{ py: 0, bgcolor: whiteColor }}>
                <MenuItem
                  sx={{ borderTop: 1, height: menuHeight }}
                  onClick={() => setIsVisibleHelp(!isVisibleHelp)}
                >
                  <ListItemIcon sx={{ ml: 2 }}>
                    <img
                      alt="help"
                      src={help}
                      width={imgWidth}
                      height={imgHeight}
                    />
                  </ListItemIcon>
                  <ListItemText>困ったときには</ListItemText>
                  <IconButton size="large">
                    {isVisibleHelp ? (
                      <KeyboardArrowUpIcon fontSize="large" />
                    ) : (
                      <KeyboardArrowDownIcon fontSize="large" />
                    )}
                  </IconButton>
                </MenuItem>
                {isVisibleHelp && (
                  <>
                    <MenuItem sx={{ py: 0 }}>
                      <ListItemIcon sx={{ ml: 2, w: imgWidth }} />
                      <ListItemText>
                        <Link
                          sx={{ color: "black" }}
                          href={urlList.guide}
                          underline="none"
                        >
                          使い方ガイド/FAQ
                        </Link>
                      </ListItemText>
                    </MenuItem>
                    <MenuItem sx={{ height: "4vh", py: 0 }}>
                      <ListItemIcon sx={{ ml: 2, w: imgWidth }} />
                      <ListItemText>
                        <Link
                          sx={{ color: "black" }}
                          href={urlList.contact}
                          underline="none"
                        >
                          お問い合わせ
                        </Link>
                      </ListItemText>
                    </MenuItem>
                  </>
                )}
                <MenuItem
                  sx={{
                    borderTop: 1,
                    borderBottom: isVisibleTerms ? 0 : 1,
                    height: menuHeight,
                  }}
                  onClick={() => setIsVisibleTerms(!isVisibleTerms)}
                >
                  <ListItemIcon sx={{ ml: 2 }}>
                    <img
                      alt="termsOfUse"
                      src={termsOfUse}
                      width={imgWidth}
                      height={imgHeight}
                    />
                  </ListItemIcon>
                  <ListItemText>規約</ListItemText>
                  <IconButton size="large">
                    {isVisibleTerms ? (
                      <KeyboardArrowUpIcon fontSize="large" />
                    ) : (
                      <KeyboardArrowDownIcon fontSize="large" />
                    )}
                  </IconButton>
                </MenuItem>
                {isVisibleTerms && (
                  <>
                    <MenuItem sx={{ py: 0 }}>
                      <ListItemIcon sx={{ ml: 2, w: imgWidth }} />
                      <ListItemText>
                        <Link
                          sx={{ color: "black" }}
                          href={urlList.rules}
                          underline="none"
                        >
                          利用規約
                        </Link>
                      </ListItemText>
                    </MenuItem>
                    <MenuItem sx={{ borderBottom: 1, py: 0 }}>
                      <ListItemIcon sx={{ ml: 2, w: imgWidth }} />
                      <ListItemText>
                        <Link
                          sx={{ color: "black" }}
                          href={urlList.policy}
                          underline="none"
                        >
                          プライバシーポリシー
                        </Link>
                      </ListItemText>
                    </MenuItem>
                  </>
                )}
              </MenuList>
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default MyPage;
